module.exports = __webpack_public_path__ + "img/art-56.658d0f1b.png";